import { PusherClient } from '@getaccept/pusher';

export const pusherClient = new PusherClient(`https://${process.env.VUE_APP_PUBLIC_API_BASE_URL}`);
